exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*.message {\r\n    margin-bottom: 5px;\r\n}\r\n\r\n.voucher-error {\r\n    margin: 10px 0;\r\n}\r\n\r\n.voucher-form {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.voucher-form .btn {\r\n    margin: 0;\r\n    margin-right: 10px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.voucher-form input[type=text] {\r\n    direction: ltr;\r\n    text-align: center;\r\n}\r\n\r\n.removeButton {\r\n    margin: 0;\r\n    margin-right: 10px;\r\n}\r\n\r\n.successfull-message {\r\n    font-size: 10px;\r\n}*/", ""]);

// exports
